import React from 'react'
import { useNavigate } from 'react-router-dom'

import mixpanel from '@disco/api/mixpanel'
import { SEARCH_APPEARS_ON_FILTER_FIELD } from '@disco/constants/search'
import {
  clearSearch,
  fetchResults,
  selectSearchPage,
} from '@disco/state-management/reducers/search-page'

import type { FilterState } from 'types/filter-page'

import { DiscoCallout } from 'components/ds'
import { NO_PLAYLISTS_FILTER_VALUE } from 'components/search/search-filters/utils'

import { useDispatch, useSelector } from 'hooks/use-redux'

// Mirrors the "Appears on" definition in pages/search/utils/useFiltersDefinition
const noPlaylistsFilter = (): FilterState[] => [
  {
    definition: {
      label: 'Appears on',
      type: 'number',
      field: SEARCH_APPEARS_ON_FILTER_FIELD,
      isNew: true,
    },
    operator: 'equals',
    value: NO_PLAYLISTS_FILTER_VALUE,
  },
]

const NoPlaylistsBanner = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { initialFetchLoaded } = useSelector(selectSearchPage)

  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault()
    mixpanel.sendPureEvent('Click link', {
      Context: 'Search',
      Type: 'No playlists banner',
      Location: 'Explorer',
    })
    dispatch(clearSearch(noPlaylistsFilter()))
    // The search page only fetches on mount when nothing has loaded yet
    if (initialFetchLoaded) dispatch(fetchResults())
    navigate('/search')
  }

  return (
    <DiscoCallout
      type="feature"
      dismissible
      dismissKey="explorer-no-playlists-banner"
      variant="soft"
      size="1"
      highContrast={false}
      mt="2"
    >
      Did you know you can quickly check if your track is not included in any
      playlist?{' '}
      <a href="/search" onClick={handleClick}>
        Show tracks with no playlists
      </a>
    </DiscoCallout>
  )
}

export default NoPlaylistsBanner
